import React from 'react';
import { PERIODS } from '../../utils/costPeriod';
import styles from './CostPeriodFilter.module.css';

// Shared month-range filter for the internal cost dashboards (system + case).
// Controlled: the parent owns periodKey / customStart / customEnd and computes
// the range via periodRange() from utils/costPeriod.
export default function CostPeriodFilter({
  periodKey,
  customStart,
  customEnd,
  onPeriodKey,
  onCustomStart,
  onCustomEnd,
}) {
  return (
    <div className={styles.wrap}>
      <div className={styles.periodBar} role="tablist" aria-label="Period">
        {PERIODS.map((p) => (
          <button
            key={p.key}
            type="button"
            className={`${styles.periodBtn} ${periodKey === p.key ? styles.periodBtnActive : ''}`}
            onClick={() => onPeriodKey(p.key)}
            aria-pressed={periodKey === p.key}
          >
            {p.label}
          </button>
        ))}
      </div>
      {periodKey === 'custom' && (
        <div className={styles.customDates}>
          <label className={styles.dateLabel}>
            Start
            <input
              type="date"
              className={styles.dateInput}
              value={customStart}
              onChange={(e) => onCustomStart(e.target.value)}
              aria-label="Custom start date"
            />
          </label>
          <label className={styles.dateLabel}>
            End
            <input
              type="date"
              className={styles.dateInput}
              value={customEnd}
              onChange={(e) => onCustomEnd(e.target.value)}
              aria-label="Custom end date"
            />
          </label>
        </div>
      )}
    </div>
  );
}
